import { useLang } from '@/i18n';
import styles from './index.module.scss';

const CompetitionSection = () => {
    const { t } = useLang('theProduct.CompetitionSection');
    const tableTh = ['', t(`th2`), t(`th3`)];
    const tableTd = [
        [t(`tr1_td1`), t(`tr1_td2`), t(`tr1_td3`)],
        [t(`tr2_td1`), t(`tr2_td2`), t(`tr2_td3`)],
        [t(`tr3_td1`), t(`tr3_td2`), t(`tr3_td3`)],
        [t(`tr4_td1`), t(`tr4_td2`), t(`tr4_td3`)],
    ];
    return (
        <section className={styles.competitionSection}>
            <div className="text-container">
                <p className="label">{t('label')}</p>
                <h2 className="title">{t('title')}</h2>
            </div>
            <table>
                <thead>
                    <tr>
                        {tableTh.map((item) => (
                            <th key={item}>{item}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {tableTd.map((v, index) => (
                        <tr key={index}>
                            {v.map((item, index) => (
                                <td key={index}>{item}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </section>
    );
};

export default CompetitionSection;
